import {FeatureCollection, Point as GeoPoint} from "geojson"
import {noop} from "lodash-es"
import {Feature} from "ol"
import {Cluster} from "ol/source"
import {GeoJSON} from "ol/format"
import {Point} from "ol/geom";
import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import mapService from "../MapService"
import {stylePoi} from "./styles"

export const poiLayer = new VectorLayer({
  updateWhileAnimating: true,
  source: new Cluster({
    distance: 50,
    minDistance: 35,
    source: new VectorSource<Feature<Point>>({features: []})
  }),
  style: stylePoi,
  properties: {id: "poi"},
  zIndex: 700
})

export interface IPoiService {
  addPoints(
    collection: FeatureCollection<GeoPoint>,
    toggleCallback?: (id: number, select: boolean) => void,
    selected?: number
  ): void
  toggleLayer(isVisible: boolean): void
  getPoiLayerSource(): VectorSource<Feature<Point>> | null
  refreshLayer(): void
}

export class PoiService implements IPoiService {

  constructor() {
    mapService.addLayer(poiLayer)
  }

  getPoiLayerSource(): VectorSource<Feature<Point>> | null {
    return (poiLayer.getSource() as Cluster<Feature<Point>>).getSource()
  }

  addPoints(
    collection: FeatureCollection<GeoPoint>,
    toggleCallback: (id: number, select: boolean) => void = noop,
    selected?: number
  ) {
    const formatter = new GeoJSON()
    if (collection.features) {
      this.getPoiLayerSource()?.addFeatures(
        (formatter.readFeatures(collection) as Feature<Point>[])
          .map(feature => {
            const id = feature.getProperties().id
            feature.setId(id)
            if (id === selected) feature.setProperties({selected: true})
            feature.set("onClick", () => {
              const select = !feature.getProperties().selected
              toggleCallback(id, select)
            })
            return feature
          })
      )
    }
  }

  toggleLayer(isVisible: boolean) {
    poiLayer.setVisible(isVisible)
  }

  refreshLayer() {
    poiLayer.getSource()?.refresh()
  }
}

export default new PoiService() as IPoiService
